import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1043"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M13.975 4.9a2.933 2.933 0 0 0-1.75-1.13c-.178-1.577-1.452-2.741-2.859-2.762-1.123-.018-2.192.696-2.695 1.804a2.89 2.89 0 0 0-1.362.553 2.887 2.887 0 0 0-.878 1.082c-1.165-.155-1.991.454-2.353 1.181a1.707 1.707 0 0 0-1.207.131c-.49.259-.873.79-.873 1.414-.001.709.491 1.289 1.08 1.51.73.274 1.378-.09 1.468-.143.169.144.792.638 1.717.639a2.667 2.667 0 0 0 1.473-.45c.177.086.507.221.932.31l-1.183 1.839a.232.232 0 0 0 .203.344h1.56c.05 0 .087.048.073.097L6.246 15.01l4.511-4.793a.231.231 0 0 0-.169-.39H9.062a.075.075 0 0 1-.063-.117l.88-1.067c.372.21.995.474 1.788.453a3.42 3.42 0 0 0 1.597-.449c.122.057.826.374 1.582.056.768-.323 1.194-1.135 1.156-1.874-.05-.968-.898-1.831-2.027-1.929z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }